import '@doger/utils/vite/define-global';
import '@doger/ui/global';
import '@doger/core/app/devtools-enabled.warning';
import './app.scss';
import '@doger/chat/shared/monitoring/sentry.monitoring';

import { memo } from 'react';

import { Pages } from '../pages';
import { AppProviders } from './app.provider';

export const App = memo(() => {
  try {
    return (
      <AppProviders>
        <Pages />
      </AppProviders>
    );
  } catch (error) {
    console.error('Error in App component:', error);

    return <div>Error loading app: {String(error)}</div>;
  }
});
